import React from "react";
import Main from "../components/smart/Main";

function NoMatch() {
  var tick = 3;
  setInterval(()=> {
    tick = tick -1;
    document.getElementById("tickSpan").innerHTML = tick;
  },1000)
  clearInterval();
  return (
      <Main Title=" "
      Description=" ">
        <div>
          <h1>404: Sorry Page Not Found</h1>
          <h2>Sending you back home in <span id="tickSpan">{tick}</span></h2>
          <h1>
            <span role="img" aria-label="Face With Rolling Eyes Emoji">
              🙄 Go back <a href="/">Home</a>
            </span>
          </h1>
        </div>
        <script type="javascript">
        setTimeout(() => {
          setTimeout(() => {
            window.location.assign("/");

          },2500)
        }, 15000)
      </script>
      </Main>
  )
}

export default NoMatch;
